import request, { RequestOptionConfig } from '../request';
import { ua } from '../ua';
import { getHash, getMarkName, getPerfEntries, getMarkPointData } from './utils';
import { perfMarkName, initMonitorSwitchStatus } from './constans';
import { TaskMapType, TaskType, TaskItemData, AnyObj } from './types';
import { getSyncHook } from '../js-api-tools';

class Task {
  private taskMap: TaskMapType = {}; // 上报任务map { [key]: Array }
  private submitErrorTaskNow: boolean = true; // 是否立即上报错误
  private submited: boolean = false; // 是否上报结束

  private mainTaskData: AnyObj = {};
  private hasSubmitMainTask: boolean = false; // 是否已经上报过主任务
  private fuseTimeout: number = 500; // 上报熔断时间
  private startTime: number = 0; // 上报熔断开始时间
  private submitTimer: any = null; // 上报延时
  private reportId: string = ''; // 上报id
  // private storeEntries: boolean = false; // 标记是否已经存储FMP之前的performance resource数据

  constructor(props: AnyObj) {
    this.reportId = props.reportId;
  }

  // 获取存储的首次上报数据
  getTaskData = () => this.mainTaskData;

  updateSubmitErrorTaskNow = (submitErrorTaskNow: boolean) => {
    this.submitErrorTaskNow = submitErrorTaskNow;
  }

  /**
   * 记录数据: 上报的同时在performance中进行标记
   * @params data 对应type类型的data数据格式。其中taskId用来标记为一个task
   * @params des: 描述性标记 例如: --weapp-monitor-markPoint-fmp 中的 fmp || 自定义埋点的描述
   * @returns taskId: 将生成的id返回,方便自定义场景用户记录一个任务的开始和结束, 例如 start-${id} end-${id}
   */
  public addTask = (type: TaskType, data: TaskItemData, des?: string, callback?: (markData: AnyObj) => void) => {
    // 切路由的时候,是否立即上报错误数据为true
    // if (type === 'route' || type === 'openWin') {
    //   this.updateSubmitErrorTaskNow(true);
    // }

    // localstore开关: 可强制终止上报
    if (localStorage.getItem('stopWeappMonitor')) return;

    if (!window?.performance) return;

    // 第一次addTask的时候就给主任务绑定timestamp.防止performance中没有该数据的情况
    if (!this.mainTaskData?.['timestamp']) {
      this.mainTaskData['timestamp'] = window?.performance?.timing?.navigationStart || ((new Date()).getTime());
    }

    // 1-按照规则生成markName
    const taskId = data.taskId || getHash();
    const markName = getMarkName(type, data, des, taskId);

    // 2-添加mark标记,并整合到上报数据中
    const markData = this.addMark(markName);
    if (markData) {
      if (type === 'custom') {
        data.taskId = taskId;
      }
      this.taskMap[type] = [
        ...(this.taskMap[type] || []),
        des === 'rmp' ? { ...markData, ...data } : { ...data, ...markData },
      ];
      callback?.(markData);

      const hook = getSyncHook('weappUtils', 'monitorTaskAddHook');
      if (hook) {
        hook(markData);
      }
      // if (markData.name?.indexOf('workflow_flowpage_form_render_first_item') !== -1) {
      //   const custom = this.taskMap['custom'];
      //   var timer: AnyObj = {};
      //   var timestamps: AnyObj = {};
      //   custom.forEach(c => {
      //     timer[c.type] = c.startTime;
      //     timestamps[c.type] = c.timestamp;
      //   });
      //   timer.workflow_base_ui_style_load = window.workflow_flowpage_passport_start_load - window.workflow_flowpage_begin;
      //   timer.workflow_base_passport_load = window.workflow_flowpage_passport_loaded - window.workflow_flowpage_passport_start_load;
      //   timer.workflow_base_vendor_load = window.workflow_flowpage_vendor_loaded - window.workflow_flowpage_passport_loaded;
      //   timer.workflow_base_utils_load = window.workflow_flowpage_utils_loaded - window.workflow_flowpage_passport_loaded;
      //   timer.workflow_base_ecode_load = window.workflow_flowpage_ui_start_load - window.workflow_flowpage_utils_loaded;
      //   timer.workflow_base_ui_load = window.workflow_flowpage_ui_loaded - window.workflow_flowpage_ui_start_load;
      //   timer.workflow_base_wx_load = window.workflow_flowpage_lib_load - window.workflow_flowpage_ui_loaded;
      //   timer.workflow_flowpage_api_start = Math.min(timer.workflow_flowpage_baseApiRequestStart, timer.workflow_flowpage_frameApiRequestStart);
      //   timer.workflow_flowpage_api_end = Math.max(timer.workflow_flowpage_baseApiRequestEnd, timer.workflow_flowpage_frameApiRequestEnd);
      //   timestamps.workflow_flowpage_api_start = Math.min(timestamps.workflow_flowpage_baseApiRequestStart, timestamps.workflow_flowpage_frameApiRequestStart)
      //   timestamps.workflow_flowpage_api_end = Math.max(timestamps.workflow_flowpage_baseApiRequestEnd, timestamps.workflow_flowpage_frameApiRequestEnd);
      //   console.table(timer);
      //   console.table(timestamps);
      //   console.table({
      //     'memory': ((performance as any)?.memory?.usedJSHeapSize || 0) / 1024 / 1024,
      //     'navigationStart': performance?.timing?.navigationStart,
      //     'workflow_flowpage_begin': window.workflow_flowpage_begin,
      //     'workflow_flowpage_passport_start_load': window.workflow_flowpage_passport_start_load,
      //     'workflow_flowpage_passport_loaded': window.workflow_flowpage_passport_loaded,
      //     'workflow_flowpage_vendor_loaded': window.workflow_flowpage_vendor_loaded,
      //     'workflow_flowpage_utils_loaded': window.workflow_flowpage_utils_loaded,
      //     'workflow_flowpage_ui_start_load': window.workflow_flowpage_ui_start_load,
      //     'workflow_flowpage_ui_loaded': window.workflow_flowpage_ui_loaded,
      //     'workflow_flowpage_lib_load': window.workflow_flowpage_lib_load,
      //   });
      //   console.table({
      //     '0. 基础加载耗时': window.workflow_flowpage_lib_load - window.workflow_flowpage_begin,
      //     '1. ui 样式加载耗时': timer.workflow_base_ui_style_load,
      //     '2. passport 加载耗时': timer.workflow_base_passport_load,
      //     '3. ecode 加载耗时': timer.workflow_base_ecode_load,
      //     '4. ui 加载耗时': timer.workflow_base_ui_load,
      //     '5. utils 加载耗时': timer.workflow_base_utils_load,
      //     '6. vendor 加载耗时': timer.workflow_base_vendor_load,
      //     '7. wx 加载耗时': timer.workflow_base_wx_load,
      //   });
      //   console.table({
      //     '0. 流程加载总耗时': timestamps.workflow_flowpage_form_render_first_item - window.workflow_flowpage_lib_load,
      //     '1. 流程(lib+main)加载耗时': timestamps.workflow_flowpage_start - window.workflow_flowpage_lib_load,
      //     '2. 流程(main)到去调用接口耗时': timestamps.workflow_flowpage_api_start - timestamps.workflow_flowpage_start,
      //     '3. 审批基础接口请求耗时': timer.workflow_flowpage_api_end - timer.workflow_flowpage_api_start,
      //     '4. 接口完成到表单模块(main)耗时': timer.workflow_flowpage_form_start - timer.workflow_flowpage_api_end,
      //     '5. 表单(main)到去调用接口耗时': timer.workflow_flowpage_form_apiRequestStart - timer.workflow_flowpage_form_start,
      //     '6. 表单接口耗时': timer.workflow_flowpage_form_apiRequestEnd - timer.workflow_flowpage_form_apiRequestStart,
      //     '7. 接口完成到开始渲染耗时': timer.workflow_flowpage_form_renderStart - timer.workflow_flowpage_form_apiRequestEnd,
      //     '8. 表单渲染出内容耗时': timer.workflow_flowpage_form_render_first_item - timer.workflow_flowpage_form_renderStart,
      //   });
      //   const pageStart = performance.timing.navigationStart;
      //   console.table({
      //     '1. 流程 main 加载 (时间点)': timer.workflow_flowpage_start,
      //     '2. form 开始加载（时间点）': window.corsImportAppTimer?.['@weapp/form']?.start - pageStart,
      //     '3. form 加载完成（时间点）': window.corsImportAppTimer?.['@weapp/form']?.libEnd - pageStart,
      //     '4. EB designer 开始加载（时间点）': window.corsImportAppTimer?.['@weapp/designer']?.start - pageStart,
      //     '5. EB designer 加载完成（时间点）': window.corsImportAppTimer?.['@weapp/designer']?.libEnd - pageStart,
      //     '6. EB ebdcoms 开始加载（时间点）': window.corsImportAppTimer?.['@weapp/ebdcoms']?.start - pageStart,
      //     '7. EB ebdcoms 加载完成（时间点）': window.corsImportAppTimer?.['@weapp/ebdcoms']?.libEnd - pageStart,
      //     '8. formbuilder 开始加载（时间点）': window.corsImportAppTimer?.['@weapp/formbuilder']?.start - pageStart,
      //     '9. formbuilder 加载完成（时间点）': window.corsImportAppTimer?.['@weapp/formbuilder']?.libEnd - pageStart,
      //     '10. 表单 main 加载 (时间点)': timer.workflow_flowpage_form_start,
      //     '11. EB ebdpage 开始加载（时间点）': window.corsImportAppTimer?.['@weapp/ebdpage']?.start - pageStart,
      //     '12. EB ebdpage 加载完成（时间点）': window.corsImportAppTimer?.['@weapp/ebdpage']?.libEnd - pageStart,
      //     '13. 表单字段渲染开始时间 (时间点)': timer.workflow_flowpage_form_render_first_item,
      //   });
      //   console.table(window.corsImportAppTimer);
      // }
    }

    // 3-错误上报,在DOMNodeInserted前的错误立即上报
    // 逻辑二次调整，允许有一些数据收集不到，即不考虑闪退场景的出现
    // if (type === 'error' && this.submitErrorTaskNow) {
    //   this.submitTask();
    // } else if (performance?.getEntriesByType?.('resource')?.length >= 200) { // resource entriese chrome上限254。快要到上限先上报清理数据
    //   this.submitTask();
    // }

    // 即将超出上限立即上报
    if (performance?.getEntriesByType?.('resource')?.length >= 200) { // resource entriese chrome上限254。快要到上限先上报清理数据
      this.submitTask();
    }

    // 4-返回uuid,方便埋点标记起始 和 结束
    return taskId;
  };

  /**
   * 上报数据
   * @params isInit: 是否为初始化上报 
   * @params submitType: 提交的类型 fmp fpt
   * @params callback: 上报的回调
   * @params updateSwitchStatus: 更新开关状态
   * tip: 第一次上报的时候,没有performance?.getEntriesByType?.('navigation')信息,通过performance.timing伪造下
   */
  public submitTask = (isInit?: boolean, submitType?: string, callback?: () => void, updateSwitchStatus?: (status: AnyObj) => void, updatePerfData?: (entries: any[]) => void) => {

    if (!window?.performance) {
      callback?.()
      return;
    }

    // localstore开关: 可强制终止上报
    if (localStorage.getItem('stopWeappMonitor')) {
      updateSwitchStatus?.({ master: false });
      callback?.()
      return;
    }

    // 如果没有登陆,就不上报。否则接口调用会失败
    const isLogined = window?.TEAMS?.currentUser?.id;
    if (!isLogined) {
      callback?.();
      return;
    }

    // 增加重复上报拦截处理,防止上一次上报还没有结束,紧接着下一次上报。导致数据重复上报的问题
    if (this.submited) {
      this.submited = false;
    } else {
      if (this.submitTimer) {
        clearTimeout(this.submitTimer);
      }
      this.submitTimer = setTimeout(() => {
        this.submitTask(isInit, submitType, callback, updateSwitchStatus);
        clearTimeout(this.submitTimer);
      }, 800);
    }

    // 增加连续上报的熔断机制: 500ms内连续执行上报接口,认为出现了死循环,熔断
    const timeNow = (new Date()).getTime();
    if (this.startTime !== 0 && submitType !== 'fmp' && submitType !== 'fpt') { // fmp tpt 基本在500ms内,需要排除
      const needFuse = timeNow - this.startTime <= this.fuseTimeout;
      if (needFuse) {
        updateSwitchStatus?.({ master: false });
        callback?.();
        return;
      } else {
        this.startTime = timeNow;
      }
    } else {
      this.startTime = timeNow;
    }

    const taskMapArr = Object.keys(this.taskMap);
    // 1、没有数据,直接return
    if (taskMapArr.length === 0) {
      callback?.();
      return;
    }

    // 2、数据接口上报
    // 2-1 上报主任务 - 保证主任务只上报一次
    /* ignoreSwitchStatus: 是否忽略开关状态(监控小工具手动上报使用) */
    const sessionStatusJson = sessionStorage.getItem('weappMonitorPageSwitchStatus');
    let ignoreSwitchStatus = false;
    if (sessionStatusJson) {
      try {
        const status = JSON.parse(sessionStatusJson);
        if (typeof status === 'object' && typeof status['master'] === 'boolean') {
          ignoreSwitchStatus = status.master;
        }
      } catch (error) {
      }
    }
    if (!this.hasSubmitMainTask) {
      this.hasSubmitMainTask = true;
      const mainTaskData = this.getMainTaskData(this.reportId);
      this.mainTaskData = mainTaskData;
      const mainTaskOptions: RequestOptionConfig = {
        url: '/api/front/monitor/report/reportData',
        method: 'POST',
        data: { ...mainTaskData, ignoreSwitchStatus }
      };
      try {
        request(mainTaskOptions).then((res: any) => {

          if (res && res.status && res.status === 404) {
            updateSwitchStatus?.({ master: false });
          }

        }).catch((err) => {
          updateSwitchStatus?.({ master: false });
        });
      } catch (error) {
        updateSwitchStatus?.({ master: false });
      }
    }

    // 2-2 上报数据
    const submitData = this.getSubmitData(isInit);
    const options: RequestOptionConfig = {
      url: '/api/front/monitor/report/reportSubData',
      method: 'POST',
      data: { ...submitData, ignoreSwitchStatus }
    };
    try {
      request(options).then((res: any) => {
        this.submited = true; // 上报完成标记
        // 更新监控开关状态
        const newStatus = {
          master: res?.data?.switchStatus || false,
          route: res?.data?.routeSwitchStatus || false,
          traceId: res?.data?.traceIdSwitchStatus || false,
          render: res?.data?.renderSwitchStatus || false,
          mobxAction: res?.data?.mobxActionSwitchStatus || false,
        }
        updateSwitchStatus?.(newStatus);
        callback?.();
      }).catch((err) => {
        updateSwitchStatus?.(initMonitorSwitchStatus);
        callback?.();
      });
    } catch (error) {
      updateSwitchStatus?.(initMonitorSwitchStatus);
      callback?.();
    }

    /* 
      3、
      (1)上报之后清除performance数据: chrome performance resource entrise 具有254上限,所以需要及时清理数据
      (2)重新标记perfMark: 下一次从新的标记点开始计算
    */
    this.clearPerf(updatePerfData);
    // performance?.clearMarks?.(perfMarkName);
    this.taskMap = {};
    performance?.mark?.(perfMarkName);
  };

  /**
   * 获取最终提交的主任务数据
   */
  private getMainTaskData = (id: string) => {
    let url = window?.performance?.getEntriesByType?.('navigation')?.[0]?.name;
    // url兼容： IE下为'document', 火狐52没有performance?.getEntriesByType?.('navigation')信息
    if (!url || url === 'document') {
      url = window?.location?.href;
    }
    const submitData = {
      id,
      url, // performance中的开始页面地址
      timestamp: this.mainTaskData['timestamp'] || window?.performance?.timing?.navigationStart || ((new Date()).getTime()), // 时间戳, 取performance的开始时间。容错情况下(new Date()).getTime()
      userAgent: window?.navigator?.userAgent, // 用户代理信息 navigator.userAgent
      ...ua,
    }
    // console?.error?.('---monitor-submitResult-mainTask--', submitData);
    return submitData;
  }

  /**
   * 获取最终提交的详细数据
   */
  private getSubmitData = (isInit?: boolean) => {
    const submitData = {
      reportId: this.reportId,
      reportData: this.mainTaskData, // 组任务上报数据一起再上报一次
      data: this.transformTaskMap(isInit), // 数据: {[key:TaskType]: TaskItemData[] }
    }
    // console?.error?.('---monitor-submitResult--', submitData);
    return submitData;
  }

  /**
   * 添加performance.mark, 
   * @returns mark后的数据
   */
  private addMark = (name: string) => {
    if (!window?.performance?.mark) return {};

    // 1、添加mark标记
    window?.performance?.mark?.(name);

    // 2、上报数据拼接上mark标记后的performance中对应的mark数据
    const markObj: AnyObj = window?.performance?.getEntriesByName?.(name)?.[0] || {};
    let markData: AnyObj = {
      url: window?.location?.href,
      name: name,
      entryType: markObj.entryType,
      startTime: markObj.startTime,
      timestamp: parseInt(markObj.startTime + this.mainTaskData['timestamp'])
    };

    // 3、markPoint情况下自动拼接 memory nodeCount相关数据
    if (name.indexOf('-markPoint-') > -1) {
      markData = { ...markData, ...getMarkPointData() }
    }

    // 4、移除mark标记
    // window?.performance?.clearMarks?.(name);

    return markData;
  }

  /**
   * 转化taskMap数据: 增加性能 和 内存 相关的数据
   * 注意、taskMap['perf'] 从标记的点开始截取,防止重复提交
   */
  private transformTaskMap = (isInit?: boolean) => {
    if (window?.performance) {
      // 获取当前 性能 + 系统暂用统计 相关的数据
      this.addTask('markPoint', {});
      this.taskMap['perf'] = getPerfEntries(this.mainTaskData['timestamp'], isInit);
    }
    return this.taskMap;
  }

  /**
   * 清除performance数据
   */
  private clearPerf = (updatePerfData?: (entries: any[]) => void) => {
    // 删除前存储下resource数据
    // if (!this.storeEntries) {
    //   const entries = window?.performance?.getEntries?.();
    //   // const FMPIndex = entries?.findIndex?.(item => item.name.indexOf('--weapp-monitor-markPoint-fmp') > -1);
    //   let toStoreEntries = [];
    //   if (!FMPIndex) {
    //     toStoreEntries = window?.performance?.getEntriesByType('resource');
    //   } else {
    //     toStoreEntries = entries?.map?.((item, index) => item.entryType === 'resource' && index < FMPIndex);
    //     this.storeEntries = true;
    //   }
    //   if (toStoreEntries.length > 0) {
    //     updatePerfData?.(toStoreEntries);
    //   }
    // }
    const toStoreEntries = window?.performance?.getEntriesByType('resource');
    if (toStoreEntries.length > 0) {
      updatePerfData?.(toStoreEntries);
    }

    // 删除非 监控标记的 mark
    const marks = performance?.getEntriesByType?.('mark');
    marks.forEach(item => {
      if (!(/--weapp-monitor/.test(item.name))) {
        window?.performance?.clearMarks?.(item.name);
      }
    })
    window?.performance?.clearMeasures?.();
    window?.performance?.clearResourceTimings?.();
  }
}

export default Task;